import { render, staticRenderFns } from "./PaymentIDeal.vue?vue&type=template&id=134bdf12&"
import script from "./PaymentIDeal.vue?vue&type=script&lang=ts&"
export * from "./PaymentIDeal.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentIDeal.vue?vue&type=style&index=0&id=134bdf12&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports